import React from 'react';

import { Flex } from '@chakra-ui/react';
import format from 'date-fns/format';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

const PastOneOnOneSetup = (param) => {
  const lastOneOnOneData = param?.data?.lastOneOnOneTime?.value ?? '';
  const lastOneOnoneDate = lastOneOnOneData ? format(new Date(lastOneOnOneData), 'PPp') : 'No 1:1 completed';

  return (
    <Flex w="100%" h="100%" alignItems="center">
      <TextBodyMedium>{lastOneOnoneDate}</TextBodyMedium>
    </Flex>
  );
};

export default PastOneOnOneSetup;
